import { ConnectFlowSurveyModel } from '@/types';
import BaseService from '@/services/api/BaseService';

class ConnectFlowSurveyService extends BaseService<ConnectFlowSurveyModel> {}

export default new ConnectFlowSurveyService('surveys');
